<template>
  <div id="">
    <app-header> </app-header>
    <div :class="paddingClass">
      <router-view :key="$route.fullPath"></router-view>
    </div>

    <Footer> </Footer>
  </div>
</template>

<script>
import AppHeader from "@/layouts/Header.vue";
import Footer from "@/layouts/Footer.vue";
export default {
  name: "BaseLayout",
  components: {
    AppHeader,
    Footer,
  },
  data() {
    return {
      property_types: null,
      base_url: this.$store.state.baseUrl,
    };
  },
  computed: {
    paddingClass() {
      return this.$route.meta.noPadding ? "px-0" : "px-4";
    },
  },
};
</script>
<style scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.padding {
  padding-left: 4px;
  padding-right: 4px;
}
.no-padding {
  padding-left: 0;
  padding-right: 0;
}
</style>
